<template>
    <div
        v-loading="loading"
        class="h-full overflow-auto space-y-1"
        @mouseleave="onHover(-1)">
        <template
            v-for="(item, index) in (items as any)"
            :key="index">
            <div
                class="hover:bg-gray-100 border-b"
                :class="extendClass"
                @mouseover="onHover(index)"
                @click="onClick(item)">
                <journey-card
                    :index="index"
                    :journey="getJourney(item)"
                    :selectable="selectable"
                    :selected-items="selectedItems"
                    :disabled="getDisableStatus(item)"
                    @change="handleChange(getJourney(item), $event)">
                    <template #actions>
                        <slot
                            name="actions"
                            :item="item"
                            :hover="hover === index" />
                    </template>
                </journey-card>
                <slot
                    name="extend"
                    :item="item"
                    :hover="hover === index" />
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import JourneyCard from './journey-card.vue'

const emits = defineEmits(['click', 'change', 'update:selected'])
const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  selected: {
    type: Array,
    default: () => []
  },
  selectable: {
    type: Boolean,
    default: true
  },
  attributeKey: String,
  extendClass: String,
  loading: Boolean,
  disableFunction: Function
})
const { items, selected, attributeKey, disableFunction } = toRefs(props)
const hover = ref(-1)
const selectedItems = computed({
  get () {
    return selected.value || []
  },
  set (val) {
    emits('update:selected', val)
  }
})

const handleChange = (journey: any, val: boolean) => {
  const exists = selectedItems.value.findIndex((i) => i === journey._id)
  if (val) {
    if (exists < 0) {
      selectedItems.value.push(journey._id)
    }
  } else if (exists >= 0) {
    selectedItems.value.splice(exists, 1)
  }
  emits('change', selectedItems.value)
}

const checkAll = (val: boolean) => {
  if (val) {
    selectedItems.value = items.value.map((i: any) => i._id)
  } else {
    selectedItems.value = []
  }
  emits('change', selectedItems.value)
}

const getJourney = (item: any) => {
  if (attributeKey?.value) {
    return item[attributeKey.value] || {}
  }

  return item
}
const getDisableStatus = (item: any) => {
  // ['chờ điều xe', 'có xe dự kiến', 'có xe chính thức']
  if (![2, 3, 4].includes(item.status)) {
    return true
  }

  // đã có xe vẫn cho điều chính thức tiếp
  // if (getJourney(item)?.vehicleStatus ) {
  //   return true
  // }
  // if (typeof disableFunction?.value === 'function') {
  //   return disableFunction.value(item)
  // }
  return false
}

const onClick = (item: any) => {
  emits('click', getJourney(item))
}

const onHover = (index: number) => {
  hover.value = index
}
defineExpose({ checkAll })
</script>
